import { render, staticRenderFns } from "./image-slider.vue?vue&type=template&id=893e56ca&scoped=true&"
import script from "./image-slider.vue?vue&type=script&lang=js&"
export * from "./image-slider.vue?vue&type=script&lang=js&"
import style0 from "./image-slider.vue?vue&type=style&index=0&id=893e56ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "893e56ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/reddeleon/Sites/watermark-designs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('893e56ca')) {
      api.createRecord('893e56ca', component.options)
    } else {
      api.reload('893e56ca', component.options)
    }
    module.hot.accept("./image-slider.vue?vue&type=template&id=893e56ca&scoped=true&", function () {
      api.rerender('893e56ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/venveo-modal/components/image-slider.vue"
export default component.exports